import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ListIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ListIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7 5.00888C7 4.45332 7.44772 4.00296 8 4.00296H21C21.5523 4.00296 22 4.45332 22 5.00888C22 5.56443 21.5523 6.01479 21 6.01479H8C7.44772 6.01479 7 5.56443 7 5.00888ZM3.5 6.51775C2.67157 6.51775 2 5.84221 2 5.00888C2 4.17554 2.67157 3.5 3.5 3.5C4.32843 3.5 5 4.17554 5 5.00888C5 5.84221 4.32843 6.51775 3.5 6.51775ZM3.5 13.5592C2.67157 13.5592 2 12.8836 2 12.0503C2 11.217 2.67157 10.5414 3.5 10.5414C4.32843 10.5414 5 11.217 5 12.0503C5 12.8836 4.32843 13.5592 3.5 13.5592ZM3.5 20.5C2.67157 20.5 2 19.8244 2 18.9911C2 18.1578 2.67157 17.4822 3.5 17.4822C4.32843 17.4822 5 18.1578 5 18.9911C5 19.8244 4.32843 20.5 3.5 20.5ZM7 12.0503C7 11.4947 7.44772 11.0444 8 11.0444H21C21.5523 11.0444 22 11.4947 22 12.0503C22 12.6058 21.5523 13.0562 21 13.0562H8C7.44772 13.0562 7 12.6058 7 12.0503ZM7 19.0917C7 18.5362 7.44772 18.0858 8 18.0858H21C21.5523 18.0858 22 18.5362 22 19.0917C22 19.6473 21.5523 20.0976 21 20.0976H8C7.44772 20.0976 7 19.6473 7 19.0917Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ListIcon;
